<script setup lang="ts">
import { computed, nextTick, ref } from "vue";
import { MessageItem } from "../../../types/localMessage";
import BaseMessageContainer from "./BaseMessageContainer.vue";
import { imageLoaded } from "../../../states/loadingMessageImage";
import TextContent from "./TextContent.vue";
import ErrorSendIcon from "../icons/ErrorSendIcon.vue";
import { fullImageViewState } from "../../../states/fullImgView";
import { scrollIfBottom } from "../../../states/scrollChatState";
import debounce from "lodash/debounce";

const props = defineProps<{
  message: MessageItem;
}>();
const imageUrl = computed(() => {
  if (props.message.content.file) {
    if ("fileId" in props.message.content.file)
      return `/api/file/preview/${props.message.content.file.fileId}`;
    else if ("localLink" in props.message.content.file) {
      return props.message.content.file.localLink as string;
    }
  } else return "";
});
const img = ref<HTMLElement>();
const loaded = (message: MessageItem) => {
  imageLoaded(message.id || "");
  if (img.value) {
    const el = img.value;
    if (el.clientWidth < 60 || el.clientHeight < 40) {
      el.style.minWidth = "60px";
      el.style.minHeight = "40px";
      el.style.objectFit = "cover";
      nextTick(() => {
        scrollIfBottom()
      })
    }
  }
};
const view = () => {
  if (props.message.content.file) {
    if (
      "fileId" in props.message.content.file &&
      props.message.content.file.preview
    ) {
      fullImageViewState.value = `/api/file/download/${props.message.content.file.fileId}`;
    } else if ("localLink" in props.message.content.file) {
      fullImageViewState.value =  props.message.content.file.localLink as string;
    }
  }
};
const openImg = debounce(view, 200)
</script>
<template>
  <BaseMessageContainer :message="message" class="image-message">
    <div class="image-message-wrapper">
      <div v-if="message.content.text" class="text font-with-emoji">
        <TextContent :content="message.content.text" />
      </div>
      <div class="image-block" @click="openImg" @dblclick="openImg">
        <div class="image-wrapper">
          <div class="time">
            <ErrorSendIcon class="err-ico" v-if="message.local?.sendError" />
            {{ message.createAt }}
          </div>
          <img ref="img" :src="imageUrl" :onload="() => loaded(message)" />
        </div>
      </div>
    </div>
  </BaseMessageContainer>
</template>
<style scoped>
.image-message-wrapper {
  width: 100%;
}

.image-message-wrapper .text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  white-space: pre-wrap;
  margin-bottom: 4px;
  word-break: break-all;
}

img {
  object-fit: contain;
  max-height: 284px;
  max-width: 100%;
  border-radius: 8px;
  margin-bottom: 1px;
}

.image-block {
  display: flex;
  cursor: pointer;
}

.image-wrapper {
  position: relative;
  display: flex;
}

.image-block .time {
  position: absolute;
  bottom: 5px;
  right: 4px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  text-align: right;
  color: rgba(236, 236, 236, 1);
  user-select: none;
  padding: 4px;
  background-color: rgba(30, 24, 24, 0.8);
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.err-ico {
  flex-shrink: 0;
  margin-right: 4px;
}
</style>
